'use strict';
import { addEvent } from './addEvent/addEvent';
import { mainPageBaner } from './mainPageBaner/mainPageBaner';
import { tns } from "tiny-slider/src/tiny-slider";

document.addEventListener('DOMContentLoaded', function () {
  window.mainPagebaner = new mainPageBaner(
    document.getElementsByClassName('main-page-baner__container')
      ? document.getElementsByClassName('main-page-baner__container')[0]
      : null
  );

  if (window.mainPagebaner) window.mainPagebaner.init();

  if (window.preloading) {
    setTimeout(() => {
      if (window.mainPagebaner) window.mainPagebaner.start();
    }, 0);
  } else {
    window.mainPagebaner.start();
    mainpageLektorzyStart();
  }
});

addEvent(window, 'load', function () {


  // goToFirstSection();
});

function goToFirstSection() {
  const toNextBtn = document.getElementsByClassName('scroll-to-first-section');
  if (toNextBtn.length == 0) return;

  let target = document.body.getElementsByClassName('offert-list-section');
  if (target.length == 0) return;
  target = target[0];

  toNextBtn[0].addEventListener('click', event => {
    event.stopPropagation();
    event.stopPropagation();

    if (window.smoothScroll) {
      window.smoothScroll.scrollIntoView(target, {
        alignToTop: true,
        onlyScrollIfNeeded: false,
      });
    } else {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
    return false;
  });
}

function mainpageLektorzyStart() {
  const tab = $(".kadra-list-container--main-page");
  if (tab.length == 0) return false;

  var slider = tns({
    container: ".kadra-list-container--main-page",
    responsive: {
      350: {
        items: 1,
      },
      500: {
        items: 2,
      },
      700: {
        items: 7,
      },
    },
    mouseDrag: true,
    swipeAngle: false,
    autoplay: true,
    controls: true,
    loop: true,
    controlsPosition: "top",
    autoplayTimeout: 3000,
    gutter: 20,
    nav: false,
    autoplayButton: false,
    //prevButton: ".prevButton",
    //nextButton: ".nextButton",
  });
}
